import './App.css';
import Header from './components/Layout/Header';
import ScrollIndicator from './components/Layout/ScrollIndicator';
import Hero from './components/Sections/Hero';
import PowerSection from './components/Sections/PowerSection';
import CarrierSection from './components/Sections/CarrierSection';
import AgentsSection from './components/Sections/AgentsSection';
import AISection from './components/Sections/AISection';
import TrackingSection from './components/Sections/TrackingSection';
import MonitorSection from './components/Sections/MonitorSection';
import IntegrationSection from './components/Sections/IntegrationSection';
import ComplianceSection from './components/Sections/ComplianceSection';
import PricingSection from './components/Sections/PricingSection';
import Footer from './components/Layout/Footer';

function App() {
  return (
    <div className="App">
      <Header />
      <ScrollIndicator />
      <main>
        <Hero />
        <PowerSection />
        <CarrierSection />
        <AgentsSection />
        <AISection />
        <TrackingSection />
        <MonitorSection />
        <IntegrationSection />
        <ComplianceSection />
        <PricingSection />
        <Footer />
      </main>
    </div>
  );
}

export default App;
